export default __webpack_public_path__ + "static/media/active.feec63d7.svg";